import React, { useContext, useState, useEffect } from 'react';
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import { useLocation } from 'react-router-dom';
import CompanySetupPage from '../CompanySetup/CompanySetup';
import TeamListPage from '../Teams/TeamList';
import RoleListPage from '../Roles/RoleList';
import UserListPage from '../User/UserList';
import IssuePriorityListPage from "../IssuePriority/IssuePriorityList";
import IssueStatusListPage from "../IssueStatus/IssueStatusList";
import UnitOfMeasureListPage from "../UnitOfMeasure/UnitOfMeasureList";
import ContractRateListPage from "../ContractRates/ContractRateList";
import AssetCategoryListPage from "../AssetCategory/AssetCategoryList";
import AssetSubCategoryListPage from "../AssetSubCategory/AssetSubCategoryList";
import FormPermissionService from "../../controller/FormPermissionController/FormPermissionController";
import CourierListPage from "../Courier/CourierList";
import CurrencyListPage from "../Currency/CurrencyList";
import TaxCodeListPage from "../TaxCodes/TaxCodeList";
import ProjectListPage from "../Project/ProjectList";
import SubJobTypeListPage from "../SubJobTypes/SubJobTypeList";
import LocationListPage from "../Location/LocationList";
import CreateAgreementSetting from "../Agreement/CreateAgreementSetting";
import LockReleaseSetting from "../LockRelease/LockRelease";
import CreateTermCondition from "../TermCondition/CreateTermCondition";
import StockCategoryListPage from "../StockCategory/StockCategoryList";
import CommentTemplateList from "../CommentTemplate/CommentTemplateList";
import EmailNotification from "../EmailNotification/CreateEmailNotification";
import GlobalSettingPage from "../GlobalSetting/GlobalSettingList";
import SageSetupPage from "../SageSetup/SageSetupForm";
import { Link, useNavigate } from 'react-router-dom';
import ImportFile from '../ImportData/Import';
import UserDefinePage from '../UserDefineFields/UserDefineFields';
import CreatePartFinancialPage from '../PartFinancial/CreatePartFinancial';
import ProjectMemberListPage from '../ProjectMember/ProjectMemberList';
import ProjectCategoryListPage from '../ProjectCategory/ProjectCategoryList';
import DateFormatListPage from '../DateFormat/DateFormatList';
import TitleListPage from '../Title/TitleList';

import OpportunitySourceListPage from '../OppurtunitySource/OpportunitySourceList';
import OpportunityStatusListPage from '../OppurtunityStatus/OpportunityStatusList';
import OppStatusListPage from '../OppStatus/OppStatusList';
import CreateDiariesLabelPage from '../DiariesLabel/CreateDiariesLabel';
import CreateVatTaxPage from '../VatTax/CreateVatTax';
import useFormSubmission from '../../../Auth/Controller/AuthController';
import ModuleService from '../../../Setup/controller/ModuleController/ModuleController';
import { SidebarContext } from '../../../Layout/SidebarContext';
import Common from '../../../Common/Common';
import CreateSerialFormatPage from '../SerialFormat/CreateSerialFormat';
import JobRoleListPage from '../JobRole/JobRoleList';
import IndustrySectorListPage from '../IndustrySector/IndustrySectorList';
import DatabasePage from '../Database/Database';
import RestorePage from '../Database/Restore';
import CompanyReportPage from '../Report/CompanyReportList';
import DocumentListPage from '../Document/DocumentList';
const MODULE_IDS = {
  Assets: 3,
  Parts: 4,
  Suppliers: 5,
  Quotations: 6,
  SalesOrders: 7,
  Purchasing: 8,
  Agreements: 9,
  Jobs: 10,
  Contacts: 15,
  Leads: 17,
  Opportunities: 18
};
function JobSetting() {
  const navigate = useNavigate();
  const redirectCallback = () => {
    navigate('/'); // Redirect to the login page
  };
  const RoleID = localStorage.getItem('RoleID');
  const HelpLink = localStorage.getItem('HelpLink');
  const location = useLocation();
  const url = new URL(window.location.origin + location.pathname);
  const pathname = url.pathname;

  const FormAction = "/AdministrationSetting";
  FormPermissionService.HasPerimssion(redirectCallback, RoleID, FormAction);
  const { theme, toggleTheme } = useContext(ThemeContext);
  let accordTheme = "accordion-header-light";
  if (theme === "dark") {
    accordTheme = "accordion-header-dark";
  }
  const [assignedModules, setAssignedModules] = useState(new Set());

  const CompanyID = localStorage.getItem("CompanyID");
  const fetchAssignedModules = async () => {
    try {

      const modules = await ModuleService.GetCompanyModules(redirectCallback, "en", CompanyID);
      const moduleSet = new Set(modules.map(m => m.PK_SearchModule_ID)); // Store assigned module IDs in a Set
      setAssignedModules(moduleSet);
    } catch (error) {
      console.error('Error fetching assigned modules:', error);
    }
  };


  useEffect(() => {

    fetchAssignedModules();

    document.querySelectorAll(".nav-link[data-toggle='pill']").forEach((tab) => {
      tab.addEventListener("click", function (event) {
        event.preventDefault(); // Prevent unwanted default behavior

        // Remove active class from all tabs
        document.querySelectorAll(".nav-link.active").forEach((activeTab) => {
          activeTab.classList.remove("active");
        });

        // Remove active class from all tab content
        document.querySelectorAll(".tab-pane.show.active").forEach((activeContent) => {
          activeContent.classList.remove("show", "active");
        });

        // Add active class to the clicked tab
        this.classList.add("active");

        // Find the corresponding tab content and activate it
        const target = this.getAttribute("href"); // e.g., "#tv-customers"
        const tabContent = document.querySelector(target);
        if (tabContent) {
          tabContent.classList.add("show", "active");

          // Automatically select the first sub-tab if available
          const firstSubTab = tabContent.querySelector(".nav-tabs .nav-link");
          if (firstSubTab) {
            // Remove active class from any other sub-tabs
            tabContent.querySelectorAll(".nav-tabs .nav-link.active").forEach((subTab) => {
              subTab.classList.remove("active");
            });

            // Activate first sub-tab
            firstSubTab.classList.add("active");

            // Activate first sub-tab content
            const firstSubTabContentId = firstSubTab.getAttribute("href");
            const firstSubTabContent = document.querySelector(firstSubTabContentId);
            if (firstSubTabContent) {
              firstSubTabContent.classList.add("show", "active");
            }
          }
        }
      });
    });
  }, []);
  const closeSubMenus = (event) => {
    // Find any open submenus
    const openSubMenu = document.querySelector(".collapse.show");

    if (openSubMenu) {
      // Check if the click is inside any submenu or its child tabs
      if (!openSubMenu.contains(event.target) &&
        !event.target.closest(".nav-link[data-toggle='collapse']") &&
        !event.target.closest(".nav-tabs") && // Prevents closing when clicking sub-tabs
        !event.target.closest(".tab-content")) { // Prevents closing when clicking content

        openSubMenu.classList.remove("show");
      }
    }
  };

  useEffect(() => {
    // Attach event listener to detect clicks outside
    document.addEventListener("click", closeSubMenus);

    return () => {
      // Cleanup event listener when component unmounts
      document.removeEventListener("click", closeSubMenus);
    };
  }, []);
  const [activeTab, setActiveTab] = useState('company'); // State to track active tab
  const [activeSubTab, setActiveSubTab] = useState('teams'); // State to track active sub-tab
  const [activeSubSubTab, setActiveSubSubTab] = useState('project'); // State to track active sub-sub-tab
  const [activePartsTab, setactivePartsTab] = useState('depots');
  const [activeAgreemntTab, setactiveAgreemntTab] = useState('aggSetting');
  const [activeAssetTab, setactiveAssetTab] = useState('category');
  const [activeSettingTab, setactiveSettingTab] = useState('taxcode');
  const [activejobTab, setactivejobTab] = useState('jobs');

  // Function to handle tab click
  const handleTabClick = (tabName) => {
    setActiveTab(tabName);
    setActiveSubTab('teams'); // Reset sub-tab when main tab changes
    setActiveSubSubTab('project'); // Reset sub-sub-tab when main tab changes
    setactivePartsTab('depots');
    setactiveAgreemntTab('aggSetting');
    setactiveAssetTab('category');
    setactiveSettingTab('taxcode');
    setactivejobTab('jobs');
  };

  // Function to handle sub-tab click
  const handleSubTabClick = (subTabName) => {
    setActiveSubTab(subTabName);
    setActiveSubSubTab('project'); // Reset sub-sub-tab when sub-tab changes
    setactivePartsTab('depots');
    setactiveAgreemntTab('aggSetting');
    setactiveAssetTab('category');
    setactiveSettingTab('taxcode');
    setactivejobTab('jobs');
  };

  // Function to handle sub-sub-tab click
  const handleSubSubTabClick = (subSubTabName) => {

    setActiveSubSubTab(subSubTabName);
  };
  const handleSubPartsTabClick = (subSubPartsTabName) => {
    setactivePartsTab(subSubPartsTabName);
  };
  const handleSubAgreementTabClick = (subSubAgreementTabName) => {
    setactiveAgreemntTab(subSubAgreementTabName);
  };
  const handleSubAssetTabClick = (subSubAssetTabName) => {
    setactiveAssetTab(subSubAssetTabName);
  };


  const [isSaved, setIsSaved] = useState(false);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    if (queryParams.get('saved') === 'true') {
      setIsSaved(true);
      setTimeout(() => {
        setIsSaved(false); // Hide the alert after 2 seconds
      }, 2000);
    }
  }, [location.search]);

  return (
    <div>
      <Common ModuleName="Dashboard" />

      <div class="main-content-header">
        <h1>Administrative Options</h1>
      </div>

      <div class="row">
        <div class="col-xl-12">
          <div class="card mb-30">
            <div class="card-body">
              <div class="row vertical-pills-tab">
                <div class="col-sm-2 pr-0">
                  <div class="nav flex-column nav-pills" id="v-pills-tab" role="tablist" aria-orientation="vertical">
                    <a class="nav-link active" data-toggle="pill" href="#tv-company">Company Setup</a>
                    <a class="nav-link" href="javascript:void(0);" data-toggle="collapse" data-target="#usr-menu">
                      User Profiles
                      <i data-feather="chevron-down" class="icon"></i>
                    </a>
                    <ul id="usr-menu" class="nav flex-column collapse collapse-level-1">
                      <li class="nav-item">
                        <ul class="nav flex-column">
                          <li class="nav-item">
                            <a class="nav-link" data-toggle="pill" href="#tv-teams">Teams</a>
                          </li>
                          <li class="nav-item">
                            <a class="nav-link" data-toggle="pill" href="#tv-roles">Roles</a>
                          </li>
                          <li class="nav-item">
                            <a class="nav-link" data-toggle="pill" href="#tv-users">Users</a>
                          </li>
                          <li class="nav-item">
                            <a class="nav-link" data-toggle="pill" href="#tv-titles">Title</a>
                          </li>
                        </ul>
                      </li>
                    </ul>
                    <a class="nav-link" href="javascript:void(0);" data-toggle="collapse" data-target="#module-menu">
                      Module Settings
                      <i data-feather="chevron-down" class="icon"></i>
                    </a>
                    <ul id="module-menu" class="nav flex-column collapse collapse-level-1">
                      <li class="nav-item">
                        <ul class="nav flex-column">
                          <li class="nav-item">
                            <a class="nav-link" data-toggle="pill" href="#tv-customers">Customers</a>
                          </li>
                          <li class="nav-item">
                            {assignedModules.has(MODULE_IDS.Jobs) ? (
                              <a class="nav-link" data-toggle="pill" href="#tv-mainJob">Jobs</a>
                            ) : (
                              <a class="nav-link disabled" data-toggle="pill" href="">Jobs</a>
                            )}


                          </li>
                          <li class="nav-item">
                            {assignedModules.has(MODULE_IDS.Parts) ? (
                              <a class="nav-link" data-toggle="pill" href="#tv-parts">Parts</a>
                            ) : (
                              <a class="nav-link disabled" data-toggle="pill" href="">Parts</a>
                            )}

                          </li>
                          <li class="nav-item">
                            {assignedModules.has(MODULE_IDS.Agreements) ? (
                              <a class="nav-link" data-toggle="pill" href="#tv-agreement">Agreements</a>
                            ) : (
                              <a class="nav-link disabled" data-toggle="pill" href="">Agreements</a>
                            )}
                          </li>
                          <li class="nav-item">
                            {assignedModules.has(MODULE_IDS.Assets) ? (
                              <a class="nav-link" data-toggle="pill" href="#tv-assets">Assets</a>
                            ) : (
                              <a class="nav-link disabled" data-toggle="pill" href="">Assets</a>
                            )}
                          </li>
                          <li class="nav-item">


                            {assignedModules.has(MODULE_IDS.Leads) || assignedModules.has(MODULE_IDS.Opportunities) ? (
                              <a class="nav-link" data-toggle="pill" href="#tv-leads">Leads/Opportunities </a>
                            ) : (
                              <a class="nav-link disabled" data-toggle="pill" href="">Leads/Opportunities</a>
                            )}

                          </li>
                          
                          <li class="nav-item">
                            <a class="nav-link" data-toggle="pill" href="#tv-lock">Lock Release</a>
                          </li>
                          <li class="nav-item">
                            <a class="nav-link" data-toggle="pill" href="#tv-reports">Reports</a>
                          </li>
                        </ul>
                      </li>
                    </ul>
                    <a class="nav-link" data-toggle="pill" href="#tv-emailing">Mail Settings</a>
                    <a class="nav-link" data-toggle="pill" href="#tv-defined-fields">User Defined Fields</a>
                    <a class="nav-link" data-toggle="pill" href="#tv-globals">Seeder Settings</a>
                     <a class="nav-link" data-toggle="pill" href="#tv-docManagement">Document Management</a>

                    <a class="nav-link" data-toggle="pill" href="#tv-imports">Imports</a>
                    <a class="nav-link" data-toggle="pill" href="#tv-database">Database</a>

                    <ul id="setting-menu" class="nav flex-column collapse collapse-level-1">
                      <li class="nav-item">
                        <ul class="nav flex-column">

                          <li class="nav-item">
                            <a class="nav-link" data-toggle="pill" href="#tv-date-format">Date Format</a>
                          </li>
                          <li class="nav-item">

                          </li>
                        </ul>
                      </li>
                    </ul>

                  </div>
                </div>

                <div class="col-sm-10 pl-0">
                  <div class="tab-content" id="v-pills-tabContent">
                    <div class="tab-pane fade active show" id="tv-company" role="tabpanel">
                      <CompanySetupPage />
                    </div>

                    <div class="tab-pane fade" id="tv-teams" role="tabpanel">
                      <TeamListPage />
                    </div>
                    <div class="tab-pane fade" id="tv-roles" role="tabpanel">
                      <RoleListPage />
                    </div>
                    <div class="tab-pane fade" id="tv-users" role="tabpanel">
                      <UserListPage />
                    </div>
                    <div class="tab-pane fade" id="tv-titles" role="tabpanel">
                      <TitleListPage />
                    </div>


                    <div class="tab-pane fade" id="tv-customers" role="tabpanel">
                      <div class="wrapper tabs-style-two">
                        <ul class="nav nav-tabs list">
                          <li class="nav-item">
                            <a class="nav-link active" data-toggle="tab" href="#hc-1">Currency Setup</a>
                          </li>
                          <li class="nav-item">
                            <a class="nav-link" data-toggle="tab" href="#hc-2">Tax Code</a>
                          </li>
                          <li class="nav-item">
                            <a class="nav-link" data-toggle="tab" href="#hc-3">Couriers</a>
                          </li>
                          


                        </ul>

                        <div class="tab-content">
                          <div class="tab-pane fade show active" id="hc-1" role="tabpanel">
                            <div class="table-responsive">
                              <CurrencyListPage />
                            </div>
                          </div>
                          <div class="tab-pane fade" id="hc-2" role="tabpanel">
                            <div class="table-responsive">
                              <TaxCodeListPage />
                            </div>
                          </div>
                          <div class="tab-pane fade" id="hc-3" role="tabpanel">
                            <div class="table-responsive">
                              <CourierListPage />
                            </div>
                          </div>
                          <div class="tab-pane fade" id="hc-4" role="tabpanel">
                            <div class="table-responsive">
                              <StockCategoryListPage />
                            </div>
                          </div>



                        </div>
                      </div>
                    </div>








                    <div class="tab-pane fade" id="tv-mainJob" role="tabpanel">
                      <div class="wrapper tabs-style-two">
                        <ul class="nav nav-tabs list">
                          <li class="nav-item">
                            <a class="nav-link active" data-toggle="tab" href="#ht-11">Projects</a>
                          </li>
                          <li class="nav-item">
                            <a class="nav-link" data-toggle="tab" href="#ht-22">Projects Members</a>
                          </li>
                          <li class="nav-item">
                            <a class="nav-link" data-toggle="tab" href="#ht-33">Projects Category</a>
                          </li>
                          <li class="nav-item">
                            <a class="nav-link" data-toggle="tab" href="#ht-4">Priorities</a>
                          </li>
                          <li class="nav-item">
                            <a class="nav-link" data-toggle="tab" href="#ht-5">Status</a>
                          </li>

                          <li class="nav-item">
                            <a class="nav-link" data-toggle="tab" href="#ht-8">Diaries</a>
                          </li>
                          <li class="nav-item">
                            <a class="nav-link" data-toggle="tab" href="#ht-7">Update Templates</a>
                          </li>
                        </ul>

                        <div class="tab-content">
                          <div class="tab-pane fade show active" id="ht-11" role="tabpanel">
                            <div class="table-responsive">
                              <ProjectListPage />
                            </div>
                          </div>
                          <div class="tab-pane fade" id="ht-22" role="tabpanel">
                            <div class="table-responsive">
                              <ProjectMemberListPage />
                            </div>
                          </div>
                          <div class="tab-pane fade" id="ht-33" role="tabpanel">
                            <div class="table-responsive">
                              <ProjectCategoryListPage />
                            </div>
                          </div>
                          <div class="tab-pane fade" id="ht-4" role="tabpanel">
                            <div class="table-responsive">
                              <IssuePriorityListPage />
                            </div>
                          </div>
                          <div class="tab-pane fade" id="ht-5" role="tabpanel">
                            <div class="table-responsive">
                              <IssueStatusListPage />
                            </div>
                          </div>

                          <div class="tab-pane fade" id="ht-7" role="tabpanel">
                            <div class="table-responsive">
                              <CommentTemplateList />
                            </div>
                          </div>
                          <div class="tab-pane fade" id="ht-8" role="tabpanel">
                            <div class="table-responsive">
                              <CreateDiariesLabelPage />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="tab-pane fade" id="tv-parts" role="tabpanel">
                      <div class="wrapper tabs-style-two">
                        <ul class="nav nav-tabs list">
                          <li class="nav-item">
                            <a class="nav-link active" data-toggle="tab" href="#pt-1">Depots</a>
                          </li>
                          <li class="nav-item">
                            <a class="nav-link" data-toggle="tab" href="#pt-2">Units</a>
                          </li>
                          <li class="nav-item">
                            <a class="nav-link" data-toggle="tab" href="#pt-3">Financial</a>

                          </li>
                          <li class="nav-item">
                            <a class="nav-link" data-toggle="tab" href="#pt-4">Serial Format</a>

                          </li>
                        </ul>

                        <div class="tab-content">
                          <div class="tab-pane fade show active" id="pt-1" role="tabpanel">
                            <div class="table-responsive">
                              <LocationListPage />
                            </div>
                          </div>
                          <div class="tab-pane fade" id="pt-2" role="tabpanel">
                            <div class="table-responsive">
                              <UnitOfMeasureListPage />
                            </div>
                          </div>
                          <div class="tab-pane fade" id="pt-3" role="tabpanel">
                            <div class="table-responsive">
                              <CreatePartFinancialPage />
                            </div>
                          </div>
                          <div class="tab-pane fade" id="pt-4" role="tabpanel">
                            <div class="table-responsive">
                              <CreateSerialFormatPage />
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                    <div class="tab-pane fade" id="tv-agreement" role="tabpanel">
                      <div class="wrapper tabs-style-two">
                        <ul class="nav nav-tabs list">
                          <li class="nav-item">
                            <a class="nav-link active" data-toggle="tab" href="#st-1">Setting</a>
                          </li>
                          <li class="nav-item">

                          </li>

                        </ul>

                        <div class="tab-content">
                          <div class="tab-pane fade show active" id="st-1" role="tabpanel">
                            <div class="table-responsive">
                              <CreateAgreementSetting />
                            </div>
                          </div>
                          <div class="tab-pane fade" id="st-2" role="tabpanel">
                            <div class="table-responsive">
                              <ContractRateListPage />
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>

                    <div class="tab-pane fade" id="tv-lock" role="tabpanel">
                      <div class="wrapper tabs-style-two">
                        <ul class="nav nav-tabs list">
                          <li class="nav-item">
                            <a class="nav-link active" data-toggle="tab" href="#lr-1">Lock Release</a>
                          </li>
                          <li class="nav-item">

                          </li>

                        </ul>

                        <div class="tab-content">
                          <div class="tab-pane fade show active" id="lr-1" role="tabpanel">
                            <div class="table-responsive">
                              <LockReleaseSetting />
                            </div>
                          </div>


                        </div>
                      </div>
                    </div>
                    <div class="tab-pane fade" id="tv-documents" role="tabpanel">
                      <div class="wrapper tabs-style-two">
                        <ul class="nav nav-tabs list">
                          <li class="nav-item">
                            <a class="nav-link active" data-toggle="tab" href="#doc-1">Company Documents</a>
                          </li>
                          <li class="nav-item">

                          </li>

                        </ul>

                        <div class="tab-content">
                          <div class="tab-pane fade show active" id="doc-1" role="tabpanel">
                            <div class="table-responsive">
                              <DocumentListPage />
                            </div>
                          </div>


                        </div>
                      </div>
                    </div>        

                    
                    <div class="tab-pane fade" id="tv-reports" role="tabpanel">
                      <div class="wrapper tabs-style-two">
                        <ul class="nav nav-tabs list">
                          <li class="nav-item">
                            <a class="nav-link active" data-toggle="tab" href="#lr-2">Terms and Conditions</a>
                          </li>
                          <li class="nav-item">
                            <a class="nav-link" data-toggle="tab" href="#lr-3">Report Management</a>
                          </li>

                        </ul>

                        <div class="tab-content">
                          <div class="tab-pane fade show active" id="lr-2" role="tabpanel">
                            <div class="table-responsive">
                              <CreateTermCondition />
                            </div>
                          </div>
                          <div class="tab-pane fade show" id="lr-3" role="tabpanel">
                            <div class="table-responsive">
                              <CompanyReportPage />
                            </div>
                          </div>


                        </div>
                      </div>
                    </div>


                    <div class="tab-pane fade" id="tv-assets" role="tabpanel">
                      <div class="wrapper tabs-style-two">
                        <ul class="nav nav-tabs list">
                          <li class="nav-item">
                            <a class="nav-link active" data-toggle="tab" href="#at-1">Category</a>
                          </li>
                          <li class="nav-item">
                            <a class="nav-link" data-toggle="tab" href="#at-2"> Sub Category</a>
                          </li>

                        </ul>

                        <div class="tab-content">
                          <div class="tab-pane fade show active" id="at-1" role="tabpanel">
                            <div class="table-responsive">
                              <AssetCategoryListPage />
                            </div>
                          </div>
                          <div class="tab-pane fade" id="at-2" role="tabpanel">
                            <div class="table-responsive">
                              <AssetSubCategoryListPage />
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>


                    <div class="tab-pane fade" id="tv-leads" role="tabpanel">
                      <div class="wrapper tabs-style-two">
                        <ul class="nav nav-tabs list">
                          <li class="nav-item">
                            <a class="nav-link active" data-toggle="tab" href="#lead-1">Source</a>
                          </li>
                          <li class="nav-item">
                            <a class="nav-link" data-toggle="tab" href="#lead-2">Leads Status</a>
                          </li>
                          <li class="nav-item">
                            <a class="nav-link" data-toggle="tab" href="#lead-3">Position</a>
                          </li>
                          <li class="nav-item">
                            <a class="nav-link" data-toggle="tab" href="#lead-4">Category</a>
                          </li>
                          <li class="nav-item">
                            <a class="nav-link" data-toggle="tab" href="#lead-5">Opportunities Status</a>
                          </li>

                        </ul>

                        <div class="tab-content">
                          <div class="tab-pane fade show active" id="lead-1" role="tabpanel">
                            <div class="table-responsive">
                              <OpportunitySourceListPage />
                            </div>
                          </div>
                          <div class="tab-pane fade" id="lead-2" role="tabpanel">
                            <div class="table-responsive">
                              <OpportunityStatusListPage />
                            </div>
                          </div>
                          <div class="tab-pane fade" id="lead-3" role="tabpanel">
                            <div class="table-responsive">
                              <JobRoleListPage />
                            </div>
                          </div>
                          <div class="tab-pane fade" id="lead-4" role="tabpanel">
                            <div class="table-responsive">
                              <IndustrySectorListPage />
                            </div>
                          </div>
                          <div class="tab-pane fade" id="lead-5" role="tabpanel">
                            <div class="table-responsive">
                              <OppStatusListPage />
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>




                    <div class="tab-pane fade" id="tv-emailing" role="tabpanel">
                      <EmailNotification />
                    </div>
                    <div class="tab-pane fade" id="tv-defined-fields" role="tabpanel">
                      <UserDefinePage />
                    </div>
                    <div class="tab-pane fade" id="tv-imports" role="tabpanel">
                      <ImportFile />
                    </div>
                    <div class="tab-pane fade" id="tv-database" role="tabpanel">
                      <div class="wrapper tabs-style-two">
                        <ul class="nav nav-tabs list">
                          <li class="nav-item">
                            <a class="nav-link active" data-toggle="tab" href="#database-1">Backup</a>
                          </li>
                          <li class="nav-item">
                            <a class="nav-link" data-toggle="tab" href="#database-2">Restoration</a>
                          </li>


                        </ul>

                        <div class="tab-content">
                          <div class="tab-pane fade show active" id="database-1" role="tabpanel">
                            <div class="table-responsive">
                              <DatabasePage />
                            </div>
                          </div>
                          <div class="tab-pane fade" id="database-2" role="tabpanel">
                            <div class="table-responsive">
                              <RestorePage />
                            </div>
                          </div>


                        </div>
                      </div>
                    </div>
                    <div class="tab-pane fade" id="tv-date-format" role="tabpanel">
                      <DateFormatListPage />
                    </div>
                    <div class="tab-pane fade" id="tv-globals" role="tabpanel">
                      <GlobalSettingPage />
                    </div>
                    <div class="tab-pane fade" id="tv-docManagement" role="tabpanel">
                        <DocumentListPage />
                    </div>
                    <div class="tab-pane fade" id="tv-sageSetup" role="tabpanel">
                      <SageSetupPage />
                    </div>

                    <div class="tab-pane fade" id="tv-db" role="tabpanel">
                      <div class="table-responsive">

                      </div>
                    </div>

                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>







    </div>

  );
}

export default JobSetting;

